import styles from './Retangulo.module.css';
import { formatValor } from '../../../service/NumberService';

const abreviaUnidades = (valor, t) => {
  let negativo = false;
  if(valor < 0){
    negativo = true;
    valor = valor * -1;
  }
  var valorlocal = valor;
  if(valor >= 1000000 && valor <= 999999999) {
      valorlocal = parseFloat(parseInt(valor) / 1000000).toFixed(3);
      return (negativo ? valorlocal * -1 : valorlocal) + t("dashboard.retangulos.milhoes");
  } else if(valor >= 1000000000 && valor <= 999999999999){
      valorlocal = parseFloat(parseInt(valor) / 1000000000).toFixed(3);
      return (negativo ? valorlocal * -1 : valorlocal) + t("dashboard.retangulos.bilhoes");
  } else return negativo ? valor * -1 : valor;
}

const Retangulo = ({cor, nome, valor, perc, abrevia, t, valor_diferenca, language}) => {
  return (
    <div style={{backgroundColor:cor}} className={styles.container_retangulo}>
         <div className={styles.nome_variavel_retangulo}>{nome}</div>
         {!isNaN(Number(valor)) ? (
          <div className={styles.valor_variavel_retangulo}>{(valor === "NaN" || isNaN(parseFloat(valor))) ? "-" : (Number.isInteger(valor) ? /*(abrevia ? abreviaUnidades(valor, t) : valor)*/ formatValor(valor, language) : parseFloat(valor).toFixed(2))}{perc != null && perc ? "%" : ""}</div>
         ) : (
          <div className={styles.valor_variavel_retangulo}>{valor}</div>
         )}
         <div className={/*styles.seta*/ 'ocultar'}>
            {(!isNaN(valor_diferenca) && valor_diferenca > 0) && <div className={styles.triangle_up}></div>}
            {(!isNaN(valor_diferenca) && valor_diferenca < 0) && <div className={styles.triangle_down}></div>}
            <div className={styles.seta_valor}>{(!isNaN(valor_diferenca) && valor_diferenca > 0) ? "+" + abreviaUnidades(valor_diferenca, t) : abreviaUnidades(valor_diferenca, t)}</div>
         </div>
         

    </div>
  )
}

export default Retangulo